/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PotionIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxklEQVR4nLVUu0oDURCNoJWVIHaB4BNrbRQxvlJl78wkkMwkWKe2tlALP0PFH5CIhW0CGr9AJT9gYeELIVYamWRX15Dd7MbNwIW9OzPnzJw7TCwW0ICk6T6xqA0GRQAdwJETwaAJ1DrBogQfMhlJeRFYyJt9IxPxPCBfOWAG+dPx6fePTCjX6WxhJhQ4Iq8ZlNcWMPELkOwjctzljwPxnu1rAvGbRYWVQOAAuTlNsKs7T6eLY16x6jPEFw6JMbnpngSGpGaDnyWTyeF0tjhpkB8ROdEtvlQqjQBxuZ3DV/7g9oMalCfLKowrKCDftKWSmpJ1y8tktic0p0UC+S1PAkA+tR9vv90NP7hnXu+exaEc2sNw7CdPXYMQeVnvLXl+Jbv2kknNosKS3Wndr4MPW6Id5x8iJ7RytzwA+XVAuXQm7U+XKA3vDlAarrk/6B7Du0Dy5bU6DMq7H8H93wQuExUXUqntUQBZ1LHttZt8JTIkJ70AoBeB3yPrbvkvASKv+S43QK72TYBcjQVZFb87RkIcfg689ADyq5oQBjzwsnOMiGcNSSXA1FSIeCoUeEc36zoZhuROK9U5B+JbIDkyGdnoGzgq+wZnScotw2fEYAAAAABJRU5ErkJggg==)
 */
export const PotionIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.07 9.4a.6.6 0 0 0-1.14 0l-.1.25a2 2 0 0 1-1.18 1.19l-.25.1a.6.6 0 0 0 0 1.13l.25.1a2 2 0 0 1 1.19 1.18l.1.25a.6.6 0 0 0 1.13 0l.1-.25a2 2 0 0 1 1.18-1.19l.25-.1a.6.6 0 0 0 0-1.13l-.25-.1a2 2 0 0 1-1.19-1.18l-.1-.25Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M14 0h-4v2H8v2h1v1.51A8.94 8.94 0 0 0 7.87 6 9 9 0 1 0 15 5.51V4h1V2h-2V0Zm-1 4h-2v2.93l-1.33.47a7 7 0 0 0-4.63 5.84c.25.11.47.27.67.47l1.23 1.23a3.62 3.62 0 0 0 5.12 0l.44-.44a5.12 5.12 0 0 1 3.62-1.5h2.8a7 7 0 0 0-4.59-5.6L13 6.93V4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
